
const productFormButtons = document.querySelector('.product-form__buttons a');
const productFormButtonsSecond = document.querySelector('.buttons-wrapper.product-form__buttons a');
const otherDiv = document.querySelector('.product__info-container');

productFormButtons?.addEventListener('click', () => {
    if (window.innerWidth > 768) {
      const isOpen = productFormButtons.dataset.open === 'true';
      otherDiv.style.paddingTop = isOpen ? '183px' : '80px';
    }
});

productFormButtonsSecond?.addEventListener('click', () => {
    if (window.innerWidth > 768) {
      const isOpen = productFormButtons.dataset.open === 'true';
      otherDiv.style.paddingTop = isOpen ? '183px' : '80px';
    }
});